import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import traditionalIdImg from '../../assets/img/traditional_id.png';
import chipIdImg from '../../assets/img/chip_id.png';
import traditionalIdExampleImg from '../../assets/img/traditional_id_example.png';
import ciNuevaSmall from '../../assets/img/nueva_miniatura.png';
import ciNueva from '../../assets/img/nueva_azul.png';
import ciViejaSmall from '../../assets/img/vieja_miniatura.png';
import ciVieja from '../../assets/img/vieja_azul.png';

export default function IdExamples({ selectedIdType, onIdTypeChange }) {

    return (
        <>
            <Box sx={{pl: 1, mt:2, mb: 2}} >
                <b>¿Qué tipo de cédula de identidad tenés?</b>
            </Box>

            <Grid container spacing={{ xs: 1, sm: 2 }}>
                <Grid
                    item
                    sm={6} xs={12}
                    onClick={() => onIdTypeChange(0)}>
                    <Box
                        sx={{backgroundColor: "white"}}
                        className={`id-examples__item ${selectedIdType === 0 ? 'id-examples__item--selected' : ''}`}>
                        <img src={ciNuevaSmall} width="60" height="40" />
                        <span>C.I. con chip</span>
                    </Box>
                </Grid>

                <Grid
                    item
                    sm={6} xs={12}
                    onClick={() => onIdTypeChange(1)}>
                    <Box
                        sx={{backgroundColor: "white"}}
                        className={`id-examples__item ${selectedIdType === 1 ? 'id-examples__item--selected' : ''}`}>
                        <img src={ciViejaSmall} width="60" height="40" />
                        <span>C.I. tradicional</span>
                    </Box>

                </Grid>
            </Grid>

            <Box sx={{ textAlign: 'center', pt: 3 }}>
                {(selectedIdType === 0) ? (
                    <img src={ciNueva} width="250" height="150" />
                ) : (
                    <img src={ciVieja} width="250" height="150" />
                )}
            </Box>
        </>
    );

}
